import { render, staticRenderFns } from "./EstiloVidaPagination.vue?vue&type=template&id=68a6860a&"
import script from "./EstiloVidaPagination.vue?vue&type=script&lang=js&"
export * from "./EstiloVidaPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports